
import OfflineQueueDB from "./offlineDBQueue";
import { ActionType, EntityType, getEntityKey, OfflineSyncStatus } from "./offlineQueueUtils";

const db = new OfflineQueueDB();

export const addToOfflineQueue = async (entityType, actionType, taskId, url, method, payload, options = {}) => {
  // Handle special case for verify & calibration queue
  const entityKey = entityType === EntityType.FIELD_ITEMS || entityType === EntityType.VERIFICATION || entityType === EntityType.CALIBRATION
    ? getEntityKey(entityType, actionType )
    : getEntityKey(entityType, actionType, taskId);

  // Apply task-specific restriction
  if (
    entityType === EntityType.TASK &&
    !(actionType === ActionType.FORM_UPDATE || actionType === ActionType.STATUS_UPDATE)
  ) {
    return; // skip if not matching task action
  }

  // Check if entityType already exists for FIELD_ITEMS or VERIFICATION
  let existing;

  if (entityType !== EntityType.CALIBRATION) {
		existing = await db.getByKey(entityKey);
    if (existing && ( entityType === EntityType.FIELD_ITEMS || entityType === EntityType.VERIFICATION)) {
			payload = updateExistingPayload(existing, payload);
		}
  }

  if (!existing) {
    const record = {
      key: entityKey,
      url,
      method,
      payload,
      entityType,
      createdAt: new Date().toISOString()
    };
    await db.addItem(record);
    return record;
  } else {
    const record = {
      payload,
      status: OfflineSyncStatus.PENDING,
      error: null,
      retryCount: 0
    };
    await db.updateItem(existing.id, record);
  }
};


export const getAllOfflineItems = async () => {
  return await db.getAllItems()
}

export const deleteItem = async (itemId) => {
  return await db.removeItem(itemId)
}

export const getItem = async (itemId) => {
  return await db.getItem(itemId)
}

export const updateQueueAfterRequest = async (itemId, status, retryCount, error, lastReqTime) => {
  await db.updateItem(itemId, {
      status,
      retryCount,
      lastReqTime: new Date().toISOString(),
      error,
      lastReqTime
    });
}

export const resolveCalibrationKeyForTask = async (taskId) => {
  const existingForTask = await db.getByTaskId(taskId);

  if (existingForTask && existingForTask.length > 0) {
    const foundCalibration = existingForTask.find(r => r.calibrationKey);
    if (foundCalibration?.calibrationKey) {
      return foundCalibration.calibrationKey;
    }
  }

  // return null if nothing found (or could generate new here if you want)
  return null;
};


const updateExistingPayload = (existingRecord, newPayload) => {
  const existingItems = existingRecord.payload.items || [];
  const newItems = newPayload.items || [];

  const mergedItems = [...existingItems];
  
  newItems.forEach(newItem => {
    const existingIndex = existingItems.findIndex(existing => existing.itemType === newItem.itemType);
    
    if (existingIndex !== -1) {
      // Same itemType found, check if itemId is different
      if (existingItems[existingIndex].itemId !== newItem.itemId) {
        // Replace with new data
        mergedItems[existingIndex] = newItem;
      }
    } else {
      // No matching itemType, add new item
      mergedItems.push(newItem);
    }
  });

  return {
    ...existingRecord.payload,
    ...newPayload,
    items: mergedItems
  };
};